var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9992 1.19995C6.03492 1.19995 1.19922 6.03565 1.19922 12C1.19922 14.026 1.76833 15.915 2.73906 17.5353L1.2959 22.7999L6.67305 21.3884C8.24564 22.2825 10.0611 22.7999 11.9992 22.7999C17.9635 22.7999 22.7992 17.9642 22.7992 12C22.7992 6.03565 17.9635 1.19995 11.9992 1.19995ZM8.30254 6.96206C8.47804 6.96206 8.65836 6.96099 8.81406 6.96909C9.00666 6.97359 9.21629 6.9877 9.41699 7.4314C9.65549 7.9588 10.1748 9.28187 10.2414 9.41597C10.308 9.55007 10.3552 9.70804 10.2625 9.88354C10.1743 10.0635 10.1284 10.1725 9.99883 10.3318C9.86473 10.4866 9.71779 10.6788 9.59629 10.7958C9.46219 10.9299 9.32372 11.077 9.47851 11.3443C9.63332 11.6116 10.1709 12.4879 10.9656 13.1953C11.9871 14.1079 12.849 14.3883 13.1172 14.5224C13.3854 14.6565 13.5407 14.6356 13.6955 14.4556C13.8548 14.2801 14.3645 13.6779 14.5445 13.4097C14.72 13.1415 14.8992 13.1879 15.1422 13.2761C15.3888 13.3643 16.7039 14.0121 16.9721 14.1462C17.2403 14.2803 17.4161 14.3467 17.4836 14.4556C17.5529 14.5681 17.553 15.1037 17.3307 15.7283C17.1084 16.352 16.0167 16.9551 15.5271 16.9974C15.033 17.0433 14.5719 17.2195 12.3156 16.3312C9.59402 15.2593 7.87765 12.4717 7.74355 12.2917C7.60945 12.1162 6.65371 10.8425 6.65371 9.52847C6.65371 8.20997 7.34501 7.56424 7.58711 7.29604C7.83371 7.02784 8.12254 6.96206 8.30254 6.96206Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.04fcdf8dc308f830a9007c56326bf70d.svg";
export { ForwardRef as ReactComponent };